import gql from 'graphql-tag';

const GET_TASK = gql`
  query task($where: TaskWhereUniqueInput!) {
    task(where: $where) {
      id
      name
      startDate
      dueDate

      recurring
      recurrenceType

      # Day of the week for weekly tasks
      weeklyDays

      # Day of the month for monthly tasks
      monthlyType
      dayOfMonth
      dayOfWeek

      #Date of the month for monthly tasks
      dateOfMonth

      # Month of the year for yearly tasks
      yearlyDate
      yearlyMonth

      requestType
      requestSubType
      requestTypeDetails
      createdBy {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      createdAt
      updatedAt
      recurring
      assigneeOrg {
        id
        name
      }

      assigneeUser {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      assigneeUsers {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      collaborators {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      followers {
        id
        name
        username
        avatar {
          id
          key
        }
      }
      channelPartner {
        id
        name
        level
      }

      advertiser {
        id
        name
      }

      taskDetails

      attachedFiles {
        id
        name
        url
        key
      }
      attachedImages {
        id
        name
        url
        key
      }
      codeSnippet
      status
      relatedCampaigns {
        id
        name
        startDate
        endDate
      }
      linkUrl
      urgency
      teams {
        id
        name
        members {
          id
          name
          username
          avatar {
            id
            key
          }
        }
        subscribers {
          id
          name
          username
        }
        subscriberTeams {
          id
          name
          members {
            id
            name
            username
          }
        }
      }
      project {
        id
        name
        owner {
          id
          name
          username
          avatar {
            id
            key
          }
          roles {
            id
            roleItems {
              feature
            }
          }
        }
        team {
          id
          name
          username
          avatar {
            id
            key
          }
          roles {
            id
            roleItems {
              feature
            }
          }
        }
      }
      projects {
        id
        name
        owner {
          id
          name
          username
          avatar {
            id
            key
          }
          roles {
            id
            roleItems {
              feature
            }
          }
        }
        team {
          id
          name
          username
          avatar {
            id
            key
          }
          roles {
            id
            roleItems {
              feature
            }
          }
        }
      }
      attachedComments {
        id
        comment
        createdAt
        createdBy {
          id
          name
          username
          avatar {
            id
            key
          }
        }
        attachedFiles {
          id
          name
          url
          key
        }
        attachedImages {
          id
          name
          url
          key
        }
        codeSnippet
      }
    }
  }
`;

export default GET_TASK;
